import {Directive} from '@angular/core';

@Directive({
    selector: '[cbTable]',
    standalone: false
})
export class CbTableDirective {
}
